
import React from "react";
import Html from "../components/utilities/Html";
import { getColor } from "../util/CC";
import { Button } from "antd";
import { useMediaQuery } from "react-responsive";

export default function SideBySideTextButton(props) {

    const template = window.sitesettings.template_info;
    const ismobile = useMediaQuery({ query: '(max-width: 716px)' })
    const { content = {} } = props;

    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    const {
        flip = false,
        text_container = true,
        container_width = 1248,
        container_align = "0 auto",
        text_background_colour = 1,
        text_padding_x = 10,
        text_padding_y = 10, 
        text_width = 50,
        text_interior_align = "center",
        button_align = "center",
        background_colour = 0,
        width = 100,
        align = "left",
        justify = "center",
        textAlign = "left",
        padding_x = 10,
        padding_y = 10,
        heading = "Heading...",
        heading_preset = 2,
        paragraph = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit. Sed at tempus ante. Interdum et malesuada fames ac ante ipsum primis in faucibus.",
        paragraph_preset = 1,
        buttons = [
            { label: "Button", link: "", tab: true },
            { label: "Button", link: "", tab: true },
            { label: "Button", link: "", tab: true },
        ],
        button_type = 1,
        button_block = false,
        link_id = 0,

        allow_mobile_overrides = false,
        mobile_flip = false,
    } = data;

    const linkOut = (_button) => {
        if (_button?.link) {
            window.open(_button.link, _button.tab ? "_blank" : "_self");
        }
    }

    const drawButton = (_button, _index) => {
        return (
            <div style={{ "flex": (button_block) ? "1 1 auto" : "unset", display: "flex", justifyContent: "center" }}>
                <Button block={button_block} className={"bm-btn-" + button_type} onClick={() => linkOut(_button)}>{_button.label}</Button>
            </div>
        )
    }

    const drawRender = () => {

        let _style = {
            padding: text_padding_y + "px " + text_padding_x + "px",
            maxWidth: width + "%",
            alignSelf: "flex-end",
            textAlign: textAlign,
            flexGrow: 1,
        }

        let containerStyle = {
            margin: container_align,
            maxWidth: (text_container) ? container_width + "px" : "100%",
            padding: padding_y + "px " + padding_x + "px",
        }

        switch (justify) {
            case "center":
                _style.alignSelf = "center";
                break;
            case "bottom":
                _style.alignSelf = "flex-end";
                break;
            default:
                _style.alignSelf = "flex-start";
                break;
        }

        
        let _stack = (flip) ? "row" : "row-reverse";

        // mobile 
        if (allow_mobile_overrides && ismobile) {
            _stack = (mobile_flip) ? "column" : "column-reverse";
        }

        return (
            <div className={(container) ? "preview-container" : ""}>
                <div style={{ background: getColor(background_colour, template)}}>
                    <div style={containerStyle}>
                        <div style={{ display: "flex", width: "100%", flexDirection: _stack, alignItems: button_align }}>
                            <div style={{ flex: '0 0 ' + (100 - text_width) + "%", display: 'flex', flexDirection: "column","justifyContent": text_interior_align }}>
                                {buttons.map((item, index) => {
                                    return drawButton(item, index);
                                })}
                            </div>
                            <div style={{flex: '0 0 ' + text_width + "%", display: "flex", justifyContent: align, background: getColor(text_background_colour, template) }}>
                                <div style={{ ..._style }}>
                                    {(heading &&
                                        <h2 style={{ "display": "block" }} className={"bm-txt-" + heading_preset} >
                                            {heading}
                                        </h2>
                                    )}
                                    {(paragraph &&
                                        <p className={"bm-txt-" + paragraph_preset} >
                                            <Html className={"bm-lnkin-" + link_id}  html={paragraph} />
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

    return drawRender();
}